import jwt_decode from 'jwt-decode';
import { getUserAuthAccount, getUserAuthToken } from 'jweb';

let token = '';
let printerInfo = {
  device_uuid: '',
  product_number: '',
  printer_sessionId: '',
  total_printers: '',
  is_hpx_scan_supported: false
};
let sessionId = null;
let rawUDLData = {};
let encryptedUDLData = {};
let appId = '';
let authAccount = { accountId: '' };
let mobileHost = false;
let locale = '';
let initialPrinterDataFetched = true;
let architecture = '';
let manufacturer = '';

export const setManufacturer = manu => {
  manufacturer = manu;
};

export const getManufacturer = () => {
  return manufacturer;
};

export const setArchitecture = arch => {
  architecture = arch;
};

export const getArchitecture = () => {
  return architecture;
};

export const getInitialPrinterDataFetched = () => {
  return initialPrinterDataFetched;
};

export const setInitialPrinterDataFetched = value => {
  initialPrinterDataFetched = value;
};

export const setJwt = newJwt => {
  token = newJwt;
};

export const getJwt = async () => {
  try {
    if (token) {
      const expiresOn = jwt_decode(token).exp;
      const currentTimeInSec = Math.floor(new Date().getTime() / 1000);
      if (expiresOn && expiresOn - currentTimeInSec <= 300) {
        // Refetch token if it expires in 5 min;
        const token = getUserAuthToken();
        setJwt(token);
      }
    }
    return token;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(`TOKEN FETCH ERROR ${error}`);
    return token;
  }
};

export const setAuthAccount = account => {
  authAccount = account;
};

export const getAuthAccount = () => authAccount;

export const setMobileHost = _mobileHost => {
  mobileHost = _mobileHost;
};

export const isMobileHost = () => mobileHost;

export const refreshAuthAccount = async () => {
  authAccount = await getUserAuthAccount();
};

export const getCurrentJwt = () => {
  return token;
};

export const setPrinterInfo = data => {
  const {
    PrinterUUID: device_uuid,
    PrinterProductNumber: product_number,
    SessionId: printer_sessionId,
    TotalPrinters: total_printers,
    IsHpxScanSupported: is_hpx_scan_supported
  } = data;
  printerInfo = {
    device_uuid,
    product_number,
    printer_sessionId,
    total_printers,
    is_hpx_scan_supported
  };
};

export const getPrinterInfo = () => {
  return printerInfo;
};

export const setSession = id => {
  sessionId = id;
};

export const getSession = () => {
  return sessionId;
};

export const setAppId = (id = '') => {
  appId = id;
};

export const getAppId = () => appId;

export const setLocale = (value = '') => {
  locale = value;
};

export const getLocale = () => locale;

export const setRawUDLData = data => {
  rawUDLData = data;
};
export const getRawUDLData = () => {
  return rawUDLData;
};

export const setEncryptedUDLData = data => {
  encryptedUDLData = data;
};
export const getEncryptedUDLData = () => {
  return encryptedUDLData;
};
